import axios from "axios";
import { API_BASE as SBIN_API_BASE } from "./base";

const API = SBIN_API_BASE;

const authHeaders = (token) => ({
  Authorization: `Bearer ${token || null || ""}`,
  "Content-Type": "application/json",
});

export async function getMySalonTaxes(token) {
  const res = await axios.get(`${API}/salons/me/taxes`, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function putMySalonTaxes(token, payload) {
  const res = await axios.put(`${API}/salons/me/taxes`, payload, {
    headers: authHeaders(token),
  });
  return res.data;
}
